import { ComponentType } from 'react';

export interface ITogglePanel {
  isOpen: boolean;
  onClose: () => void;
  onOpen: () => void;
}

export function TogglePanel<T>(
  OpenComponent: ComponentType<T & ITogglePanel>,
  ClosedComponent: ComponentType<T & ITogglePanel>,
) {
  return function ToggleComponent(props: T & ITogglePanel) {
    const { isOpen, onClose, onOpen, ...other } = props;

    const handleCloseChange = () => {
      onClose();
    };

    const handleOpenChange = () => {
      onOpen();
    };

    if (isOpen) {
      return <OpenComponent {...(other as T & ITogglePanel as any)} onClose={handleCloseChange} />;
    }
    return <ClosedComponent {...(other as T & ITogglePanel as any)} onOpen={handleOpenChange} />;
  };
}
